var rangetouchExports = {};
var rangetouch = {
  get exports(){ return rangetouchExports; },
  set exports(v){ rangetouchExports = v; },
};

export { rangetouch as __module, rangetouchExports as exports };
